import { Component, OnInit, Input, ViewChild, TemplateRef } from '@angular/core';
import { DocumentService } from '@app/_services/masters/document.service';
import { document } from '@app/_models/document';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { NgbModalConfig, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { LogService } from '../../../_shared/log.service'

@Component({
  selector: 'app-document-master-edit',
  templateUrl: './document-master-edit.component.html',
  styleUrls: ['./document-master-edit.component.css']
})
export class DocumentMasterEditComponent implements OnInit {
  docId: number;
  editDocumentForm: FormGroup;
  document: document[];
  submitted = false;
  documentName: string;
  response: any;
  documentId: number;
  getresponse: any;
  strMessage:string;

  get f() { return this.editDocumentForm.controls; }

  showModalBox: boolean = false;
  @ViewChild('showModalBox', { read: TemplateRef }) showModalBoxTemplate: TemplateRef<any>;

  constructor(private eventService: LogService, private formBuilder: FormBuilder, private documentService: DocumentService,
    private modalService: NgbModal, config: NgbModalConfig) { }

  @Input() childMessage: document[];

  receiveDocumentId(p) {
    this.docId = p;
  }

  ngOnInit(): void {
    
    console.log("childMessage" + this.childMessage);
    this.response = this.childMessage;
    this.documentName = this.response.documentName;
    this.documentId = this.response.id;
    this.editDocumentForm = this.formBuilder.group({
      documentName: ['', Validators.required]
    });
  }

  updateDocument() {
    this.submitted = true;

    if (this.editDocumentForm.invalid) {
      return;
    }
    var v = new document();
    v.documentName = this.documentName;
    v.id = this.documentId;
    this.documentService.updateDocument(v)
      .subscribe((response) => {
        if (response) {
          this.getresponse = response;
          if (this.getresponse.respMessage == "Success") {
            this.strMessage="Document Updated Successfully.";
            this.modalService.open(this.showModalBoxTemplate);
            var v = response;
          }
          else if (this.getresponse.respMessage == "Failure") {
            this.strMessage=this.getresponse.respData;
            this.modalService.open(this.showModalBoxTemplate);
            var v = response;
          }
        }
      },
        (err: any) => {
          var message = err;
        });
  }

  refresh(): void {
    this.modalService.dismissAll(this.showModalBoxTemplate);
    this.eventService.emit<string>('4');
  }
  goBack()
  {
    this.eventService.emit<string>('4');
  }

}
